import { BaseClient } from '../base-client.js';
import { BASE_URLS } from '../../config';
import RequestResponseHelpers from '../../helpers/RequestResponseHelpers';
import Utils from '../../helpers/utils';
import { setServerLog } from '../../helpers/ServerLogStorageUtil';
import axios from 'axios';

class DnSubscriptionClient extends BaseClient {
  constructor(config) {
    super(config);
    this.baseUrl = this.baseUrl || BASE_URLS.DN_SUBSCRIPTION_API;
    if (this.isServer) {
      this.config.headers['X-API-TOKEN'] = this.config.API_TOKEN || this.config.headers['X-API-TOKEN'] || '';
    }
  }

  shouldSendLogToServer(config, isError) {
    return Utils.shouldSendLogToServer(config, isError);
  }

  getIpCompany(slug = '', username = '') {
    let url = 'v1/ip-register';
    if (slug) {
      url = `${url}/${slug}`;
    }
    return this.get({
      url,
      params: { username },
      'axios-retry': RequestResponseHelpers.getDefaultAxiosRetryConfig()
    });
  }

  validateIpLoginToken(token) {
    const url = `/v1/ip-tokens/validate/${token}`;
    return this.get({
      url,
      'axios-retry': RequestResponseHelpers.getAxiosRetryConfig(
        2,
        2000,
        RequestResponseHelpers.get5xxStatuses()
      )
    });
  }

  fetchUser() {
    const url = 'user/info';
    return this.get({
      url,
      'axios-retry': RequestResponseHelpers.getDefaultAxiosRetryConfig()
    });
  }

  registerForIpSubscription(slug = '', data) {
    let url = 'v1/ip-register';
    if (slug) {
      url = `${url}/${slug}`;
    }
    return this.post({
      url,
      data,
      'axios-retry': RequestResponseHelpers.getDefaultAxiosRetryConfig()
    });
  }

  ipPopupStatus() {
    const url = 'v1/ip-login/lightbox';
    const extraInfo = {
      noCache: true
    };
    return this.get({ url, extraInfo });
  }

  async serverLog(conf = {}) {
    const config = this.generateRequestConfigForSendingLogToServer(conf);
    const extraHeaders = {};
    extraHeaders[this.traceIdHeader] = config.traceId;
    const headers = Object.assign({}, conf.headers, extraHeaders);
    const request = { ...config, headers, method: 'POST' };
    RequestResponseHelpers.generateClientSideCsrf(request);
    this.logger.info('Sending log to server');
    try {
      const resp = await axios(request);
      return resp.data;
    } catch (err) {
      if (err.response) {
        this.logger.error(`Failed to send server log. Request: ${JSON.stringify(request)} Status: ${err.response.status}`);
      }
      setServerLog(request);
    }
  }

  generateRequestConfigForSendingLogToServer(config) {
    const url = `/oneid/auth/logging/${config.level}`;
    const client = this.clientName;
    config.data = config.data || {};
    const data = {
      ...config.data,
      client,
      message: config.message
    };
    const newConfig = {
      ...config,
      url,
      data
    };
    return newConfig;
  }
}

export { DnSubscriptionClient };
